import React from 'react';
import { useNavigate } from 'react-router-dom';
import image67 from '../../assets/image67.png';
import '../../styles/shared/PopularCategories.css';

const categories = [
  { name: '2 Pre-Rolls', items: 74 },
  { name: 'Sativa', items: 35 },
  { name: 'Sativa', items: 12 },
  { name: 'Hash Holes', items: 22 },
  { name: 'High Times', items: 33 },
  { name: 'Hash Holes', items: 9 },
  { name: 'High Times', items: 52 },
  { name: 'Sativa', items: 29 },
  { name: 'Hash Holes', items: 26 },
  { name: '2- gram Pre-Rolls', items: 5 },
];

const PopularCategories: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="pop-cats">
      <div className="pop-cats__container">
        <h2 className="pop-cats__title">POPULAR CATEGORIES</h2>
        <div className="pop-cats__grid">
          {categories.map((cat, i) => (
            <button
              key={i}
              className="pop-cats__item"
              onClick={() => navigate(`/products?category=${encodeURIComponent(cat.name)}`)}
            >
              <div className="pop-cats__text">
                <span className="pop-cats__name">{cat.name}</span>
                <span className="pop-cats__count">{cat.items} Items</span>
              </div>
              <div className="pop-cats__thumb">
                <img src={image67} alt={cat.name} />
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCategories;
